import { render } from "./TrainingManagement.vue?vue&type=template&id=5f8204e2&scoped=true"
import script from "./TrainingManagement.vue?vue&type=script&lang=js"
export * from "./TrainingManagement.vue?vue&type=script&lang=js"

import "./TrainingManagement.vue?vue&type=style&index=0&id=5f8204e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8204e2"]])

export default __exports__